import { memo, useCallback } from 'react';

import type { ProposalListItem } from '../../lib/proposals/core/types';
import {
  RowApproveButton,
  RowDismissButton,
} from './ProposalListApproveButton';

interface RowHoverActionsProps {
  action: ProposalListItem;
  disabled: boolean;
  onApprove: (action: ProposalListItem) => void;
  onDismiss: (action: ProposalListItem) => void;
}

// Hover-revealed per-row ✕/✓ — rendered into GroupedList's renderItemActions
// slot, which owns positioning, reveal, and click isolation.
export const RowHoverActions = memo(function RowHoverActions({
  action,
  disabled,
  onApprove,
  onDismiss,
}: RowHoverActionsProps) {
  const handleApprove = useCallback(() => {
    onApprove(action);
  }, [onApprove, action]);

  const handleDismiss = useCallback(() => {
    onDismiss(action);
  }, [onDismiss, action]);

  return (
    <>
      <RowDismissButton
        onClick={handleDismiss}
        ariaLabel={`Dismiss ${action.title}`}
        disabled={disabled}
      />
      <RowApproveButton
        onClick={handleApprove}
        ariaLabel={`Approve ${action.title}`}
        disabled={disabled}
      />
    </>
  );
});
